<template>
  <div>
    <div
      class="d-flex justify-content ml-2 align-items-center my-2 cursor-pointer"
      @click="goBack()"
    >
      <button
        class="btn btn-sm rounded-circle p-25"
        :class="isDark ? 'btn-danger' : 'btn-primary'"
      >
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div class="ml-1 text-capitalize text-dark goback-text">
        {{ $t("actions.go_back") }}
      </div>
    </div>
    <!-- Table Container Card -->
    <b-card class="m-2" no-body>
      <b-card-header class="pb-50">
        <h5 class="text-capitalize">
          <span v-if="!isUpdating">{{ $t("actions.add") }}</span>
          <span v-else>{{ $t("actions.update") }}</span>
        </h5>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="refFormObserver" v-if="!isLoadingTemplate">
          <div class="m-2">
            <b-row>
              <!-- Tenant Selection -->
              <b-col cols="12" md="4" class="mb-1 mb-md-0">
                <validation-provider
                  #default="validationContext"
                  name="tenant"
                  rules="required"
                >
                  <label class="d-block">{{ $tc("tenants.title", 1) }}</label>
                  <v-select
                    :options="tenantOptions"
                    v-model="idTenant"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :reduce="(val) => val.value"
                    :placeholder="$t('custom_forms.select_tenant')"
                    class="w-100"
                    append-to-body
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>

              <!-- Template Name -->
              <b-col cols="12" md="4">
                <validation-provider
                  #default="validationContext"
                  name="Template name"
                  rules="required"
                >
                  <label class="d-block">
                    {{ $t("risk.template.name") }}
                  </label>
                  <b-form-input
                    v-model="templateName"
                    class="d-inline-block mr-1"
                    :placeholder="$t('risk.template.name')"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>

              <!-- Related forms Selection -->
              <b-col cols="12" md="4">
                <label class="d-block">{{
                  $tc("custom_forms.types.related_forms", 1)
                }}</label>
                <v-select
                  :options="relatedFormsOptions"
                  v-model="relatedForms"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :placeholder="$t('custom_forms.select_related_forms')"
                  class="w-100"
                  multiple
                  @search="onSearchRelatedForms"
                  label="name"
                  :filterable="false"
                  :clearable="false"
                />
              </b-col>

              <!-- User Selection -->
              <b-col cols="12" md="4" class="mt-1 mb-md-0">
                <label class="d-block">{{ $tc("users.title", 2) }}</label>
                <v-select
                  :options="allowedUsersFiltered"
                  v-model="id_users_allowed_fill"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :placeholder="$t('custom_forms.select_users')"
                  class="w-100"
                  multiple
                  label="name"
                  @search="onSearchUsers"
                />
              </b-col>

              <!-- Read Only User Selection -->
              <b-col cols="12" md="4" class="mt-1 mb-md-0">
                <label class="d-block">{{ $t("custom_forms.read_only_users") }}</label>
                <v-select
                  :options="readOnlyUsersFiltered"
                  v-model="read_only_users"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :placeholder="$t('custom_forms.select_users')"
                  class="w-100"
                  multiple
                  label="name"
                  @search="onSearchUsers"
                />
              </b-col>

              <!-- User group Selection -->
              <b-col cols="12" md="4" class="mt-1 mb-md-0">
                <label class="d-block">{{ $tc("custom_forms.user_group", 1) }}</label>
                <v-select
                  :options="usersGroupOptions"
                  v-model="id_group_allowed_fill"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :placeholder="$t('custom_forms.select_user_group')"
                  class="w-100"
                  multiple
                  @search="onSearchUserGroup"
                  label="name"
                />
              </b-col>

              <!-- is Prefill Selection -->
              <b-col cols="12" md="12" class="mt-2 mb-md-0">
                <b-form-checkbox
                  id="prefillTemplateSwitch"
                  v-model="prefillTemplate"
                  name="check-button"
                  switch
                  inline
                >
                  <span>{{ $t("custom_forms.prefill_template") }}</span>
                </b-form-checkbox>

                <b-form-checkbox
                  id="requiresPrefillSwitch"
                  v-model="requiresPrefill"
                  name="check-button"
                  switch
                  inline
                >
                  <span>{{ $t("custom_forms.requires_prefill") }}</span>
                </b-form-checkbox>

                <b-form-checkbox
                  id="displayInAlarmSwitch"
                  v-model="displayInAlarm"
                  name="check-button"
                  switch
                  inline
                >
                  <span>{{ $t("custom_forms.display_in_alarm") }}</span>
                </b-form-checkbox>

                <b-form-checkbox
                  id="isHorizontalSwitch"
                  v-model="isHorizontal"
                  name="check-button"
                  switch
                  inline
                >
                  <span>{{ $t("custom_forms.is_horizontal") }}</span>
                </b-form-checkbox>
                <b-form-checkbox
                  id="isMakerCheckerSwitch"
                  v-model="isMakerChecker"
                  name="check-button"
                  switch
                  inline
                >
                  <span>{{ $t("custom_forms.is_cheker_maker") }}</span>
                </b-form-checkbox>
              </b-col>

              <hr>

              <b-col
                cols="12"
                md="4"
                class="d-flex flex-row mb-1 mb-md-0 mt-2"
              >
                <b-form-checkbox
                  id="mailableSwitch"
                  v-model="isMailable"
                  name="check-button"
                  switch
                  inline
                >
                  <span>{{ $t("custom_forms.is_mailable") }}</span>
                </b-form-checkbox>
                <b-form-checkbox
                  id="allowDraftSwitch"
                  v-model="allowDraft"
                  name="check-button"
                  switch
                  inline
                >
                  <span>{{ $t("custom_forms.allow_draft") }}</span>
                </b-form-checkbox>
              </b-col>

              <!-- Template Name -->
              <b-col cols="12" md="4">
                <validation-provider
                  v-if="isMailable"
                  #default="validationContext"
                  name="recipient"
                  rules="required|email"
                >
                  <label class="d-block">
                    {{ $t("custom_forms.types.recipient") }}
                  </label>
                  <b-form-input
                    v-model.trim="recipient"
                    type="email"
                    class="d-inline-block mr-1"
                    :placeholder="$t('custom_forms.types.recipient')"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>

              <b-col
                cols="12"
                md="4"
                class="d-flex flex-column mb-1 mb-md-0 mt-2"
              >
                <div class="d-flex flex-column align-items-end justify-content-end">
                  <b-button
                    variant="success"
                    v-if="$can('create', 'OpSecurityFormTemplate')"
                    @click="onSave()"
                    :disabled="!isValid"
                  >
                    <span class="text-nowrap text-capitalize">
                      {{ $t("actions.save") }}
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
        <div class="ml-1 mt-2" v-else>
          <div class="d-flex">
            <div class="">
              <SkeletonLoading class="mb-2" :width="350" :height="37" />
              <SkeletonLoading :width="350" :height="37" />
              <SkeletonLoading class="mt-1" :width="45" :height="25" />
            </div>
            <div class="">
              <SkeletonLoading class="ml-2 mb-2" :width="350" :height="37" />
              <SkeletonLoading class="ml-2" :width="350" :height="37" />
            </div>
          </div>
          <div class="mt-3 mr-4">
            <SkeletonLoading class="w-100" :height="100" />
          </div>
        </div>
        <div class="mx-2 mb-2" v-if="!isLoadingTemplate">
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <div class="w-100">
                <div class="">
                  <operationalSecurityTemplateBuilder
                    ref="builderRef"
                    :items.sync="items"
                    :is-valid.sync="isValid"
                    @save-changes="onSave()"
                    @updateItems="updateItems"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormInvalidFeedback,
} from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import useTemplateBuilderConfig from "./useTemplateBuilderConfig";
import store from "@/store";
import { computed, ref, onMounted } from "@vue/composition-api";
import operationalSecurityTemplateBuilder from "@/components/operationalSecurityTemplateBuilder";
import SkeletonLoading from "@/components/SkeletonLoading.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
    vSelect,
    operationalSecurityTemplateBuilder,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    SkeletonLoading,
  },
  setup(_, context) {
    const {
      isValid,
      items,
      templateName,
      recipient,
      refFormObserver,
      required,
      isUpdating,
      idTenant,
      id_users_allowed_fill,
      id_group_allowed_fill,
      read_only_users,
      usersOptions,
      usersGroupOptions,
      prefillTemplate,
      requiresPrefill,
      isMailable,
      isMakerChecker,
      displayInAlarm,
      isHorizontal,
      isLoadingTemplate,
      relatedFormsOptions,
      relatedForms,
      allowDraft,
      addItem,
      save,
      getValidationState,
      updateItems,
      onSearchUsers,
      onSearchUserGroup,
      onSearchRelatedForms,
      getUsersGroup,
      getUsers,
      userLabel,
      getTemplatesRF,
    } = useTemplateBuilderConfig();

    const builderRef = ref(null);
    const isDark = computed(() => store.state.appConfig.layout.skin === "dark");
    const goBack = () =>
      context.root.$router.push({ name: "operationalSecurityTemplates" });

    onMounted(() => {
      store.dispatch("tenant/getAll");
      getUsersGroup();
      getUsers();
      getTemplatesRF();
    });

    const tenantOptions = computed(() => store.getters["tenant/getSelectedItems"]);

    const allowedUsersFiltered = computed(() => {
      const readOnlyIds = new Set(read_only_users.value.map((u) => u.id));
      return usersOptions.value.filter((u) => !readOnlyIds.has(u.id));
    });

    const readOnlyUsersFiltered = computed(() => {
      const allowedIds = new Set(id_users_allowed_fill.value.map((u) => u.id));
      return usersOptions.value.filter((u) => !allowedIds.has(u.id));
    });

    //Override of onsave to store tenant
    const onSave = async () => {
      const validation = await refFormObserver.value.validate();
      if (!validation) return;
      await save({ id_tenant: idTenant.value });
    };

    const onAddSection = () => {
      // call public method of builder
      builderRef.value && builderRef.value.addSection && builderRef.value.addSection();
    };

    return {
      isDark,
      isValid,
      items,
      templateName,
      recipient,
      refFormObserver,
      required,
      isUpdating,
      tenantOptions,
      idTenant,
      builderRef,
      id_users_allowed_fill,
      id_group_allowed_fill,
      read_only_users,
      usersOptions,
      usersGroupOptions,
      prefillTemplate,
      requiresPrefill,
      isMailable,
      isMakerChecker,
      displayInAlarm,
      isHorizontal,
      isLoadingTemplate,
      relatedFormsOptions,
      relatedForms,
      allowDraft,
      goBack,
      addItem,
      save,
      onSave,
      getValidationState,
      updateItems,
      onAddSection,
      onSearchUsers,
      onSearchUserGroup,
      onSearchRelatedForms,
      userLabel,
      allowedUsersFiltered,
      readOnlyUsersFiltered,
    };
  },
};
</script>

<style lang="scss" scoped>
.arrow-icon {
  font-size: 12px;
}

.goback-text {
  position: relative;
  top: 0.1rem;
  margin-left: 0.5rem !important;
}

::v-deep .vs__selected-options {
  max-height: 70px;
  min-height: 42px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
</style>
